<style scoped>
.anchor-app-menu-logo-container {
  top: 50%;
  transform: translateY(-75px);
}

.anchor-app-menu-logo {
  background-color: #042641;
  padding: 2rem;
}
</style>

<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    min-width="100%"
    elevation="0"
    content-class="app-menu flat-top-border elevation-1"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn class="mr-1" icon v-on="on">
        <v-icon
          id="navbar-apps-btn"
          :color="nonProd ? 'white' : 'black'"
        >
          mdi-apps
        </v-icon>
      </v-btn>
    </template>
    <v-card class="flat-top-border" :elevation="0">
      <v-container fluid>
        <v-row>
          <v-col sm="12" md="3" :class="{'mb-5': $vuetify.breakpoint.smAndDown }">
            <v-card max-width="250" flat class="anchor-app-menu-logo-container center-x">
              <div class="anchor-app-menu-logo">
                <v-img src="../../resources/imgs/logo-dark.png" />
              </div>
              <v-card-text class="text--primary title text-center">
                Anchor Web Apps
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-row
              v-for="(category, idx) in items"
              :key="idx"
            >
              <v-col
                v-for="item in category"
                :key="item.label"
                class="d-flex child-flex"
              >
                <v-card
                  :id="`app-link-${item.permission}`"
                  max-width="150"
                  :href="item.link"
                  :disabled="user.permissions ? !user.permissions.includes(item.permission) : true"
                >
                  <v-img :src="item.src" />
                  <v-card-text class="text--primary pa-1 text-center">
                    {{ item.label }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import appsMixin from '../../mixins/appsMixin';


export default {
  name: 'AnchorAppsMenu',
  mixins: [appsMixin],
  props: {
    nonProd: Boolean,
    user: Object,
  },
};
</script>
